export const APP_NAME = 'WiFi Footprint';
